import React from 'react';
import {
  SvgIcon
} from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';




export default function InfoIconCarre(props: SvgIconProps) {
  return (
    <SvgIcon {...props} className="icon-svg" sx={{ fontSize: '1.49rem', height: 'auto', display:"block !important"}}>

        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.94025 10.1835V4.77301H6.99347V10.1835H5.94025ZM6.47214 3.93818C6.28897 3.93818 6.13164 3.87713 6.00013 3.75502C5.87097 3.63055 5.8064 3.48261 5.8064 3.31118C5.8064 3.13741 5.87097 2.98947 6.00013 2.86735C6.13164 2.74289 6.28897 2.68066 6.47214 2.68066C6.65531 2.68066 6.81147 2.74289 6.94063 2.86735C7.07214 2.98947 7.13789 3.13741 7.13789 3.31118C7.13789 3.48261 7.07214 3.63055 6.94063 3.75502C6.81147 3.87713 6.65531 3.93818 6.47214 3.93818Z" fill="#4B5B8E"/>
        <circle cx="6.47217" cy="6.43213" r="5.5" stroke="#4B5B8E"/>
        </svg>

    </SvgIcon>
  );
}
